export default {
	common: {
		webName: 'MiraStudent',
		login: '登录',
		startImmediately: '立即开始',
		delete: '删除',
		experienceClass: '体验课',
		enter: '请输入',
		cancel: '取消',
		confirm: '确认',
		select: '请选择',
		operationSuccessful: '操作成功',
		upload: '上传',
		classID: '课堂ID',
		wantToDelete: '确定要删除吗？',
		studyReport: '学习报告',
		submit: '提交',
		userCenter: '个人中心',
		setting: '设置',
		updataSuccess: '提交成功，请等待审核',
		balance: '帮余额',
		simplifiedChinese: '简体中文',
		traditionalChinese: '繁体中文',
		English: '英语',
		Japanese: '日语',
		Korean: '韩语',
		courseCancelled: '课程已取消',
		contactTeacher: '联系老师',
		numberClass: '{num}堂课',
		endTime: '到期时间',
		setSuccess: '设定成功',
		studentsUpload: '学生上传',
		teacherUpload: '老师上传',
		hour: '小时',
		class: '堂',
		fivetyminutes: '50分钟'
	},
	headers: {
		searchTeachers: '搜索教师',
		recommendTeachers: '推荐老师',
		becomeTeacher: '成为老师',
		teacherPortal: '老师入口',
		balance: 'MIRA帮余额'
	},
	footers: {
		about: '关于',
		pavilionToUs: '关于我们',
		used: '如何使用',
		becomeTeacher: '成为老师',
		naturalResources: '资源',
		study: '学习专栏',
		help: '帮助',
		contactUs: '联络我们',
		questions: '常见问题',
		pay: '付款方式',
		refund: '退款政策',
		socialize: 'MiraStudent 社交'
	},
	mainIndex: {
		titleOne: '1对1 专业老师',
		titleTwo: '个性化教学·互动专注学习',
		titleThree: '线上補習平台',
		titleFour: 'MiraStudent 是一个线上的補習平台，以教育科技打破地域和时间界限，让学生安在家中',
		titleFive: '都能获得专业教师的指导，节省时间，提升学习效率和能力，轻松应付考试!',
		titleSubject: '热门补习科目',
		viewMore: '浏览更多',
		invitationalEducation: '寻找能启发你学习潜能的老师',
		introduce: '我们有注册教师、专科老师、语言专家、社会专业人士，助你解决不同学习需求',
		reasonForSelection: '选择 MiraStudent 的原因',
		reasonTitleOne: '师资优良专科专教',
		reasonContentOne: '所有老师都经严格筛选身份、履历和学历都经查阅大多为注册教师 具教授专科经验',
		reasonTitleTwo: '自由轻松学习',
		reasonContentTwo: '打破传统实体学习框架在网上随时随地上课省却舟车劳顿压力轻松愉快学习',
		reasonTitlethree: '度身订造专属课程',
		reasonContentThree: '一对一的专业老师\n为你订造独一无二的课程\n培养你的学习兴趣和提升应试能力',
		reasonTitlefour: '收费合理公平',
		reasonContentFour: '学费由老师自由定价按自己的预算 选购适合课堂如课程不满意 可申请退回余下学费',
		classProcess: '上课流程',
		processOne_1: '寻找适合老师',
		processOne_2: '按老师的履历、自我介绍短片、学生部分挑道合转的搏师',
		processOne_3: '建罐缚踝前·先与老师满通及购买「幢验踝J试试老师是否通合堰',
		processTwo_1: '预约课堂',
		processTwo_2: '购课后，在老师的日程表预约其开放的时间·待其确认',
		processTwo_3: '学生可在上课前24小时前，更改或取消预约',
		processThree_1: '开始上课',
		processThree_2: '学生在上课前，可在MT账户内下载老师的笔记(如有)上课时间到，学生可用电脑、手机或平板电脑，在MT账户内打开VOOV视频教室上课课堂完成后，如有作业，学生需在MT账户内下载及完成后上传回网站，待老师批改',
		obtainIncome: '透过与学生分享你的专业知识以赚取收入',
		onlineTeaching: '注册以开始使用 MiraStudent 线上授课',
		evaluate: '听听MiraStudent学生的评价'
	},
	cashDesk: {
		cashRegister: '收银台',
		goods: '商品',
		subject: '科目',
		category: '类别',
		time: '时间',
		classNum: '堂数',
		total: '小计',
		single: '单堂',
		discount: '优惠',
		selectCoupon: '选择优惠券',
		noCoupon: '暂不选择',
		couponDiscount: '购买体验课抵扣',
		totalCount: '总价',
		paymentMethod: '支付方式',
		payment: '使用MT币',
		balance: '余额',
		noBalance: '余额不足，点击充值',
		pay: '确认并支付',
		purchaseSuccessful: '购买成功'
	},
	forStudy: {
		skipQuestion: '跳过问题',
		chooseMentor: '自行挑选老师',
		studyFor: '你想学什么 ?',
		budget: '每堂课的预算是 ?',
		country: '你的国家/地区 ?',
		classTime: '上课的时间 ?',
		mentorLevel: '老师级别?',
		motherTongue: '母语者 ?',
		masterLanguage: '同时掌握的语言?',
		weekMon_weekFri: '周一~周五',
		weekend: '周六、周日',
		anyTime: '任何时间'

	},
	forClassIndex: {
		languageLevel: '语言级别',
		onlineTeacher: '线上英语老师',
		seacher: '搜寻老师姓名或关键字',
		class: '课程',
		pleaseSelect: '请选择',
		budget: '每堂学习预算',
		country: '来自国家/地区',
		classTime: '上课时间',
		schedulingPeriod: '排课时段',
		mentorLevel: '老师级别',
		brfore: '以前',
		motherTongue: '母语者',
		masterLanguage: '同时掌握的语言',
		suitable: '位适合你需求的老师',
		new: 'NEW',
		highQualityMentor: '次优质老师',
		seniorTutor: '资深老师',
		professionalTeacher: '专业老师',
		professor: '教授',
		speek: '会说',
		learnMore: '了解详情',
		minute: '分钟',
		poetryHall: '试堂',
		trialClass: '预约试听课程',
		contactMentor: '联络老师',
		viewClass: '查看完整课堂安排表'
	},
	personalizationTeacher: {
		seacherTeacher: '寻找你的个性化老师',
		hint: '花1分钟回答几条简单问题，以助匹配最适合你的老师',
		studyFor: '你学习的目的是？',
		start: '开始',
		selectTeacher: '自行挑选老师'
	},
	teacherVue: {
		information: '关于{name}的资讯',
		teachingSubjects: '教学科目',
		professorlevel: '教授级别',
		highestEducationLevel: '最高学历',
		experience: '特殊教育需要经验',
		aboutMe: '关于我',
		videoIntroduction: '影片介绍',
		cannotPlay: '不支持视频播放',
		classTime: '授课时间',
		resume: '履历',
		evaluate: '评价',
		myClass: '我的课堂',
		testClassTime: '1堂25分钟课',
		formalClasses: '正式课',
		formalClassTime: '{number}堂50分钟课',
		priceAdjustment: '老师课堂价格将在{time}调价'
	},
	login: {
		login: '登录',
		welcome: '欢迎来到MiraStudent !',
		hint: '请以下方式继续登录或创建账号，说明你已阅读并同意 MiraStudent 服务条款和松协议。',
		loginMethod: '使用{way}登录',
		or: '或者',
		email: '电子邮箱',
		emailAccount: '你的电子邮件地址',
		password: '密码',
		passwordPlaceholder: '请输入密码',
		forgotPassword: '忘记密码',
		rememberMe: '记住我',
		toLogin: '登录',
		noAccount: '还未有账户 ？',
		register: '注册',
		editPassword: '修改密码',
		retry: '{countdown}秒后重试',
		send: '发送验证码',
		code: '验证码',
		codePlaceholder: '请输入验证码'

	},
	studentsCom: {
		calendar: '行事历',
		month: '月',
		week: '周',
		reportCourseNotCompleted: '报告课程未完成',
		situationDescription: '很抱歉你的课程没有按预期完成，请如实填写以下信息以说明你的情况',
		whyNotCompleted: '*为什么你的课程未完成?',
		solution: '*你的预期解决方案是什么?',
		explanation: '解释和证明',
		explanationContent: '如果你有任何证据支持你的请求，请尽可能多的提供，以得最佳结果',
		uploadImage: '上传最多5张圈片或影片作为证明',

		// 我的课堂
		myClass: '我的课堂',
		bookNewClassroom: '预约新课程',
		list: '列表',
		waitingClass: '待上课',
		completed: '已完成',
		pendingConfirmation: '待确认课程',
		enterClassroom: '进入课堂',
		upcomingCourses: '即将到来的课程',
		waitingConfirm: '待老师确认',
		waitingConfirmstudent: '待学生确认',
		confirmAfterClass: '课后待确认',
		confirmed: '已确认',
		calendar: '日历',

		// 我的作业
		myWork: '我的作业',
		// 我的笔记
		myNotes: '我的笔记',
		// 我的老师
		myTeacher: '我的老师',
		reserve: '预约',
		chat: '对话',
		giveExtra: '加赠',
		recommendedTeacher: '推荐的老师',
		professionalTeacher: '专业老师',
		seniorTeacher: '资深老师',
		myTest: '我的测验',


		resolved: '已解决',
		selectSolutionTip: '请选择与学生商定后的解决方案，提交后由学生在48小时内进行确',
		selectSolution: '请选择调解方案',
		selectPlaceholder: '请选择',
		fillRefundAmount: '请填写退款金额',
		feeDeductionTip: '该课的学费先扣退款金额，在扣佣金，剩除部分打入老师钱包',


		teacherEvaluation: '老师评价',
		classSatisfaction: '课堂满意度',
		selectTeachingTraits: '选择适合老师{name}的教学特质标签',
		showOnProfileNamed: '此回复将展示在老师的个人页面(记名)',
		showOnProfileAnonymous: '此回复将展示在老师的个人页面(匿名)',
		writeClassExperience: '写下你的上课体验心得',
		classFeedback: '给予老师{name}的课堂回馈',


		tradingOrder: '交易订单',
		completedOrders: '已完成订单',
		refundedOrders: '已退课订单',
		transactionTime: '交易时间',
		teacherName: '老师姓名',
		courseContent: '课程内容',
		amount: '金额',
		orderNumber: '订单号',

		unresolved: '未解决',
		uploadDataDecision: '上传证据由平台决定',
		explanationAndProof: '解释和证明',
		uploadEvidenceTip: '如果你有任何证据支持你的请求，请尽可能多的提供，以得最佳结果',


	},
	userMySetting: {
		setting: '设置',
		logOut: '退出登录',
		basicInfo: '基本资料',
		photo: '照片',
		uploadAvatarTip: '请按头像上传清晰的个人头像',
		name: '名字',
		inputNamePlaceholder: '请输入姓名',
		gender: '性别',
		selectPlaceholder: '请选择',
		male: '男',
		female: '女',
		timeZone: '时区',
		currency: '货币',
		birthday: '生日',
		displayLanguage: '显示语言',
		country: '所在国家',
		save: '储存',
		accountVerification: '账号验证',
		email: '电子邮箱',
		inputEmailPlaceholder: '请输入',
		sendVerificationEmail: '发送验证信',
		password: '密码',
		editPassword: '修改密码',
		bindApp: '绑定app',
		facebook: 'Facebook',
		google: 'Google',
		wechat: 'Wechat',
		clickToBind: '点击绑定',
		unbind: '解绑',
		confirmLogout: '确定退出登录吗？',
		logoutContent: '退出登录',
		confirm: '确定',
		cancel: '取消',

	},
	userMyWallet: {
		myWallet: '我的钱包（学生）',
		recharge: '储值',
		availableBalance: '可用结余',
		approximateAmountTip: '*此处所列金额为近似值，可能因汇率变动而有轻微差别，所有金额均以美元为单位',
		walletTransactionDetails: '钱包交易详情',
		time: '时间',
		item: '事项',
		amount: '金额',
		orderId: '订单ID',
		classNumber: '课堂号'
	},
	userCenter: {
		greeting: '你好！',
		nickname: '昵称',
		todolist: '行事历',
		myCoursesPackage: '我的课程套餐',
		myCourses: '我的课程',
		classBalance: '课堂余额',
		appointment: '预约',
		viewClass: '查看课堂',
		myCoupons: '我的优惠券',
		newUserCoupon: '新用户注册10元优惠券',
		minimumConsumption: '最低消费门槛',
		validTime: '可用时间',
		myHomework: '我的作业',
		completedHomework: '份已完成作业',
		myTest: '我的测验',
		noIncompleteTest: '没有未完成的测验',
		learningReport: '学习报告',
		personalizedRecommendation: '个人化推荐',
		todayHot: '本日热门',
		fromUK: '来自英国',
		nativeLanguage: '母语',
		hourlyCharge: '每小时收费',
		ticketPackage: '套票方案',
		discount: '折扣',
		recommendationReason: '推荐理由',
		bookNow: '立即预约',
		toDoList: '待办事项',
		timeLimitedOffer: '限时优惠',
		purchase: '购买',
		remainingTime: '剩余时间',
		teacherAppointmentConfirm: '教师发送课时预约确认',
		timeZone: '时区',
		confirm: '确认',
		reject: '拒绝',
		reportContent: '份/最近3个月',
	},
	appointment: {
		appointmentCourse: '预约课程',
		teacher: '老师',
		coursePackage: '课堂包',
		remainingClasses: '剩余堂数',
		selectedClasses: '已选取',
		availableClasses: '尚可选取',
		contactTool: '联络工具',
		selectContactTool: '这些是老师使用的联络工具，请选择联络工具',
		nextStep: '下一步',
		cancel: '取消',
		confirm: '确认',
		reservationSuccess: '预约成功',
		appointmentClass: '预约堂数',
		classDate: '课程日期',
		time: '时间',
		selectContact: '请选择联系方式'
	},
	teacherConfirms: {
		// 模板部分翻译
		week: '星期',
		year: '年',
		month: '月',
		day: '日',
		utcTime: '(UTC+08:00)',
		classId: '课时ID:',
		language: '语言',
		duration: '时长',
		price: '价格',
		languageCategory: '语言类别',
		languageType: '语言类',
		restTimeNote: '一些老师可能会在课程时间中包括5分钟的休息时间。',
		contactTool: '联络工具',
		avatar: '偶人会议ID',
		password: '密码',
		teacherEntryTime: '老师进入课室时间:',
		studentEntryTime: '学员进入课室时间:',
		notes: '笔记',
		homework: '作业',
		test: '测验',
		uploadHomework: '上传作业',
		uploadTest: '上传测验',
		pendingTeacherConfirm: '待老师确认预约',
		yourClassPending: '你的课时等待老师确认',
		cancelReschedulePolicy: '如需取消或重新预约课时，请先阅读我们的',
		pendingConfirm: '待确认预约',
		classPendingConfirm: '课堂等待确认',
		pendingClass: '待上课',
		classStartOnTime: '你的课时将于预约的时间开始',
		classCompletedPendingConfirm: '完课待确认',
		confirmWithin3Days: '请在课程结束后的 3天内确认，否则系统将在{time}({timeZone})自动确认课程',
		reportClassNotCompleted: '如果你的课程没有像预期的那样结束，你可以点击“课程未完成” 来报告。',
		completed: '已完成',
		rateTeacherWithin3Days: '请在确认课程后3天内给予老师评价',
		classCompletedCongrats: '恭喜，本节课程已完成',
		classNotCompleted: '课程已处理',
		waitingTeacherProcess: '等待老师处理，老师将{time}({timeZone}) 前处理。',
		classNotCompletedResultConfirm: '课程未完成处理结果确认',
		processWithin48Hours: '请在48小时内{time} ({timeZone}) 前处理。',
		teacherSolution: '老师处理方案：',
		refundAmount: '退款金额：',
		agree: '同意',
		applyPlatformRuling: '申请平台裁决',
		waitingPlatformRuling: '等待平台裁决',
		pleaseWaitPlatform: '请等待平台处理',
		confirmClass: '确认课程',
		cancelClass: '取消课堂',
		enterClassroom: '进入教室',
		interruptNote: '如遇中断，请再按此按钮进入教室',
		accomplishClass: '确认课程',
		classNotAccomplished: '课程未完成',
		rateTeacher: '评价老师',
		viewEvaluation: '查看评价',
		// JS 部分翻译
		confirmCancel: '确定要取消吗？',
		cancelClassText: '取消课堂',
		confirmAction: '确定',
		cancelAction: '取消',
		operationSuccess: '操作成功',
		confirmAppointment: '确定要确认预约吗？',
		confirmAppointmentText: '确认预约',
		enterClassroomText: '进入教室',
		confirmCompletion: '确定要确认课程完成吗？',
		confirmCompletionText: '确认课程完成',
		confirmDelete: '确定要删除吗？',
		deleteText: '删除',
		confirmAgree: '确定要同意吗？',
		agreeResultText: '同意处理结果',
		confirmPlatformRuling: '确定要申请平台裁决吗？',
		platformRulingText: '申请平台裁决',
		policy: '《取消和重新预约政策》'
	},
	addClass: {
		addCourse: '添加课程',
		type: '种类',
		pleaseSelect: '请选择',
		courseName: '课程名称',
		classNumber: '堂数',
		discount: '折扣',
		teacherEarningsPerClass: '老师应得/每堂',
		displayPricePerClass: '显示价钱/每堂',
		noDiscount: '无',
		referenceMarketValue: '参考市值:最少{currency}$80堂，每堂为50分钟',
		cancel: '取消',
		save: '保存',
		confirmCancel: '确定要取消吗？',
		saveSuccess: '保存成功',
		popular: '热门'
	},
	classManage: {
		currentLevel: '现时等级',
		upgrade: '距离下次升级还有{hour}小时',
		viewCommissionRatio: '查看分成比例',
		priceAdjustmentNotice: '价钱调整公示中',
		setClassTypeAndPrice: '设置课堂种类和价钱',
		trialClass: '体验课',
		oneClass25Minutes: '1堂25分钟课',
		save: '保存',
		addCourse: ' + 添加课程',
		confirmDelete: '确定要删除吗？',
		deleteCourse: '删除该课程',
		submitSuccess: '提交成功，请等待审核',
		operationSuccess: '操作成功',
		cancel: '取消',
		effectiveTime: '生效时间',
		revokeModifications: '撤销修改',
		setPrice: '设定价格'
	},
	myClassTeacher: {
		myClassroom: '我的课堂',
		waitingStudentConfirm: '待学生确认',
		startingToday: '今日即将开始',
		waitingMyConfirm: '待我确认的课堂',
		futureClassroom: '未来的课堂',
		completed: '已完成',
		exception: '异常',
		confirmCancel: '确定要取消吗？',
		submitSuccess: '提交成功',
		operationSuccess: '操作成功',
		contactTools: '联络工具',

	},
	myStudents: {
		onCampusStudents: '在校学生',
		archivedStudents: '存档学生',
		student: '学生',
		learnedCourse: '所学课程',
		prepaidBalance: '预付余额',
		remainingBalance: '剩余余额',
		woXueZhiReport: '窝学智报告', // 保留特定名称未翻译
		communication: '通讯',
		appointmentClass: '预约课堂',
		learningReport: '学习报告',
		pleaseFill: '请填写',
		operationSuccess: '操作成功',
		confirm: '确认',
		cancel: '取消',
		classHour: '课时'
	},
	resolved: {
		title: '已解决',
		solutionInfo: '请选择与学生商定后的解决方案，提交后由学生在48小时内进行确认',
		selectSolution: '*请选择调解方案',
		pleaseSelect: '请选择',
		none: '无',
		courseCompleted: '课程已完成',
		returnOnce: '退回一次',
		partialRefund: '部分退款',
		fillRefundAmount: '*请填写退款金额',
		feeInfo: '该课的学费先扣退款金额，再扣佣金，剩余部分打入老师钱包',
		confirm: '确认',
		cancel: '取消',
		confirmResolve: '确定已经解决吗？',
		resolveText: '解决',
		operationSuccess: '操作成功'
	},
	schedule: {
		teachingTime: '授课时间',
		availableTeachingTime: '可授课时间',
		addTimeSlot: '+添加时间段',
		generatedTeachingTime: '生成的可授课时间如下：',
		effectiveDate: '生效日期',
		always: '总是',
		until: '直到',
		save: '保存',
		confirmDelete: '确定要删除吗？'
	},
	statistics: {
		total: '总计',
		netIncomeTotal: '净收益总额',
		unparticipatedTrials: '你没有参加的审判', // 可能需根据上下文调整
		tutoringHours: '辅导时数',
		averageRating: '平均评分',
		totalRatings: '评分总数',
		totalStudents: '学生总数',
		averageClassRating: '平均课时评分',
		allCoursesStudentAvgRating: '你所有课程的学生平均评分',
		hoursPerStudent: '每名学生的小时数',
		calculationMethod: '它是通过你的辅导课时数除以学生总数来计算的。',
		attendanceStatus: '你的缺勤情况',
		annualPerformanceLast365Days: '最近365天的年度表现(最后更新日期为2025年2月7日)',
		profileViews: '个人资料浏览量',
		studentConversionRate: '对学生的转化率',
		effectiveClassHours: '有效上课时长',
		hourlyRate: '小时费率',
		newStudents: '新来的学生',
		activeStudents: '活跃的学生',
		classHoursPerActiveStudent: '每个活跃学生的课时',
		trialClassRating: '试听课评分',
		allTime: '所有时间',
		thisMonth: '本月',
		thisWeek: '本周',
		downloadIncomeReport: '下载收益报告'
	},
	teacherSet: {
		teacherAccountSetting: '老师账号设定',
		cloaking: '隐身',
		uncloaking: '未隐身',
		setToCloaking: '设为隐身',
		cancelCloaking: '取消隐身',
		teacherInfo: '老师资料',
		avatar: '头像',
		name: '名字',
		surname: '姓氏',
		speakLanguages: '会说语言（可多选）',
		select: '请选择',
		level: '级别',
		professorLevel: '教授级别',
		specialEducationExperience: '特殊教育经验',
		educationBackground: '学历',
		certificate: '证书',
		synopsis: '一句话简介',
		selfIntroduction: '自我介绍',
		imageIntroduction: '图片介绍',
		video: '影片',
		uploadVideo: '上传影片',
		inputYoutubeLink: '请输入Paypal账号', // 原"翰入"修正为"输入"
		inputzhuanshukuai: '请输入转数快账号', // 保留"转数快"作为特定名称
		confirm: '确认',
		cancel: '取消',
		save: '保存',
		dataUnderReview: '资料审核中，请勿重新提交...',
		paymentMethod: '收款方式',
		paypal: 'Paypal',
		zhuanshukuai: '转数快',
		contactTools: '联络工具',
		zoom: 'Zoom',
		meetingLink: '会议链接',
		personalMeetingNumber: '个人会议号码(PMI)',
		meetingRoomPassword: '会议室密码',
		voov: 'VOOV',
		submitSuccess: '提交成功'
	},
	unresolved: {
		platformProcessing: '提交未解决申请后，由平台处理',
		unresolved: '未解决'
	},
	viewCommission: {
		commissionRatio: '分成比例',
		level: '级别',
		hours: '时数',
		mtExtraction: 'MT抽成',
		classCalculationNote: '50分钟堂，当1小时计算，体验课不计',
		gotIt: '我知道了'
	},
	wallet: {
		myWalletTeacher: '我的钱包（老师）',
		withdraw: '提款',
		availableBalance: '可用结余',
		totalBalance: '总结余',
		pendingBalance: '待批结余',
		approximateAmountNote: '*此处所列金额为近似值，可能因汇率变动而有轻微差别，所有金额均以美元为单位',
		walletTransactionDetails: '钱包交易详情',
		withdrawalDetails: '提款详情',
		time: '时间',
		item: '事项',
		amount: '金额（{currency}）',
		courseId: '课程ID',
		status: '状况',
		cancelWithdrawal: '取消提款',
		myWalletTutor: '我的钱包 (老师)',
		transferToStudentWallet: '转账至学生钱包',
		withdrawFromInternalAccount: '从内部账户提取款项',
		transferMethod: '转账方式',
		paypal: 'Paypal',
		fps: '转数快',
		email: '电子邮件',
		enter: '请输入',
		withdrawAmount: '提取金额',
		maxWithdraw: '最多可提取 {amount}{currency}',
		cancel: '取消',
		withdrawProfit: '提取收益',
		transferToStudent: '转账至学生钱包',
		confirm: '确认',
		operationSuccess: '操作成功',
		confirmCancel: '确定要取消吗？',
	},
	becomeTeacher: {
		becomeTeacher: '成为老师',
		fillPersonalInfo: '1 填写个人资料',
		uploadPhoto: '2 上传照片',
		uploadCertificate: '3 上传证书',
		fillEducation: '4 填写学历',
		fillIntroduction: '5 填写个人介绍',
		uploadVideo: '6 上传影片',
		fillTeachingTime: '7 填写授课时间',
		fillTuition: '8 填写学费',
		startCreateProfile: '开始创建你的公共老师个人资料。当你完成每一部分时你的进度将自动保存。你可以随时返回完成注册',
		name: '名字',
		pleaseFill: '请填写',
		surname: '姓氏',
		speakLanguages: '会说语言（可多选）',
		level: '级别',
		professorLevel: '教授级别',
		specialEducationExperience: '特殊教育经验',
		nextStep: '下一步',
		photo: '照片',
		previousStep: '上一步',
		certificate: '证书',
		education: '学历',
		synopsis: '一句话简介',
		selfIntroduction: '自我介绍',
		imageIntroduction: '图片介绍',
		inputYoutubeLink: '请输入Youtube链接',
		confirm: '确认',
		teachingTime: '授课时间',
		availableTeachingTime: '可授课时间',
		addTimeSlot: '+添加时间段',
		generatedTeachingTime: '生成的可授课时间如下：',
		effectiveDate: '生效日期',
		always: '总是',
		until: '直到',
		setClassTypeAndPrice: '设置课堂种类和价钱',
		viewCommissionRatio: '查看分成比例',
		trialClass: '体验课',
		one25MinClass: '1堂25分钟课',
		formalClass: '正式课',
		addCourse: '+ 添加课程',
		submit: '提交',
		submitSuccess: '提交成功，请等待审核',
		hint1: '请输入名字',
		hint2: '请输入姓氏',
		hint3: '请选择会说的语言与级别',
		hint4: '请选择教授级别',
		hint5: '请选择特殊教育经验',

	},
	teacherIndex: {
		teacherCenter: '老师中心',
		myClass: '我的课堂',
		myStudents: '我的学生',
		classManagement: '课堂管理',
		schedule: '日程',
		statistics: '统计',
		wallet: '钱包',
		settings: '设定',
	},
	statusConfirms: {
		appointmentCourse: '预约课程',
		teacher: '老师',
		coursePackage: '课堂包',
		remainingClasses: '剩余堂数',
		selectContactTool: '这些是老师使用的联络工具，请选择联络工具',
		contactTool: '联络工具',
		nextStep: '下一步',
		confirmReservation: '确认预约',
		cancel: '取消',
		confirm: '确认',
		selectContactWay: '请选择联系方式',
		reservationSuccess: '预约成功',
		week: '星期',
		hoursFormat: '{start} / {end}',
		classId: '课时ID:',
		courseName: '课程名称',
		language: '语言',
		duration: '时长',
		price: '价格',
		languageCategory: '语言类别',
		languageType: '语言类',
		breakNote: '一些老师可能会在课程时间中包括5分钟的休息时间。',
		contactToolSection: '联络工具',
		meetingId: '偶人会议ID',
		password: '密码',
		teacherEntryTime: '老师进入课室时间:',
		studentEntryTime: '学员进入课室时间:',
		notes: '笔记',
		uploadNotes: '上传笔记',
		homework: '作业',
		uploadHomework: '上传作业',
		test: '测验',
		uploadTest: '上传测验',
		waitingStudentConfirmClass: '你的课时等待学生确认',
		waitingStudentConfirm: '待学生确认预约',
		waitingConfirm: '待确认预约',
		waitingClass: '待上课',
		classCompletedConfirm: '完课待确认',
		classCompleted: '已完成',
		classNotCompleted: '课程已处理',
		studentConfirm: '学生将在课程结束后的 3 天内确认，否则系统将在{finish_time} ({timeZone}) 自动确认课程。',
		studentMarkedNotCompleted: '学生标记课程未完成，请在 {time} ({timeZone}) 前处理。以下是学生填写内容',
		notCompletedReason: '因{reason}原因课程未完成，希望可以{expectedResult}',
		content: '{content}',
		resolved: '已解决',
		unresolved: '未解决',
		waitingPlatformDecision: '等待平台裁决',
		confirmCourse: '确认课程',
		cancelClass: '取消课堂',
		enterClassroom: '进入教室',
		reenterNote: '如遇中断，请再按此按钮进入教室',
		accomplishCourse: '确认课程',
		courseNotCompleted: '课程未完成',
		confirmCancel: '确定要取消吗？',
		operationSuccess: '操作成功',
		cancelAndReschedulePolicy: '《取消和重新预约政策》',
		teacherhandlingplan: '老师处理方案',
		refundAmount: '退款金额',
		processWithin48Hours: '等待学生确认，学生将在48小时内 {time}({timeZone})前处理。',
		result1: '课程已完成',
		result2: '退回一次',
		result3: '部分退款'
	},
	classTime: {
		selectCourseStartTime: '请选择课程的开始时间({timeZone})',
		obtained: '已获取',
		noCourse: '暂无课程',
	},
	introductionTeacher: {
		introduceTeacher: '介绍老师',
		recommendTeacherTip: '可填写被推荐的老师用户名，平台审核通过后，首3个月内被推荐的老师获得的时数将会同时加到你的累计时数中',
		recommendTeacher: '推荐老师',
		inputTeacherEmail: '请输入老师的邮箱账号',
		confirm: '确定',
		recommendedTeachers: '已推荐老师',
		pendingReview: '待审核',
		close: '关闭',
		operationSuccess: '操作成功'
	},
	recharge: {
		recharge: '充值',
		rechargeAmount: '充值金额',
		inputPrompt: '请输入',
		thirdPartyFee: '第3方支付手续费(不能退款) + 5%',
		totalPrice: '总价',
		cancel: '取消',
		submit: '提交',
		confirmRecharge: '确定要进行充值吗？',
		rechargeBalance: '充值余额',
		rechargeSuccess: '充值成功'
	}
}